import React from 'react';

function Report() {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">
        
      </h2>
      <div className="bg-white rounded-lg shadow p-6">
       
        <p></p>
      </div>
    </div>
  );
}

export default Report;

